import RecipientWellWithFindControlViewState from 'owa-recipient-common/lib/store/schema/RecipientWellWithFindControlViewState';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PeopleIdentity from 'owa-service/lib/contract/PeopleIdentity';
import peopleIdentity from 'owa-service/lib/factory/peopleIdentity';

/**
 * Maps the recipient well from the rule edit page to PeopleIdentity type
 * @return the PeopleIdentity list with the corresponding recipients as items
 */
export default function mapRecipientWellWithFindControlViewStateToPeopleIdentity(
    recipientWell: RecipientWellWithFindControlViewState
): PeopleIdentity[] {
    // map conditional clauses
    let peopleIdentities: PeopleIdentity[] = [];

    for (let recipient of recipientWell.recipients) {
        let mailbox: EmailAddressWrapper = recipient.persona.EmailAddress;
        let identity = peopleIdentity({
            DisplayName: mailbox.Name,
            SmtpAddress: mailbox.EmailAddress,
            RoutingType: mailbox.RoutingType,
        });
        peopleIdentities.push(identity);
    }

    return peopleIdentities.length > 0 ? peopleIdentities : null;
}
